import { useQuery } from "@tanstack/react-query";
import { getOpportunityDetail } from "@/helpers/apis";
import { GET_OPPORTUNITY_DETAIL } from "../constants";

interface UseOpportunityDetailQueryArgs {
  opportunity_id: string;
  instance_id: number;
  enabled?: boolean;
}

export const useOpportunityDetailQuery = ({
  opportunity_id,
  instance_id,
  enabled = true,
}: UseOpportunityDetailQueryArgs) => {
  return useQuery({
    queryKey: [GET_OPPORTUNITY_DETAIL, opportunity_id, instance_id],
    queryFn: () => getOpportunityDetail({ opportunity_id, instance_id }),
    enabled: enabled && Boolean(opportunity_id) && Number.isFinite(instance_id),
  });
};
